// src/lib/mobileNotificacoes.js
// Sino de notificações para os shells mobile (supervisor/cliente/funcionário).
// Reaproveita a tabela `notificacoes` (mesma do topbar desktop). Lista + marca lidas.

import { openModal } from './modal.js';
import { sb } from '../api/supabaseClient.js';
import { tenant } from '../context/tenantContext.js';
import { esc } from './dom.js';

export async function contarNotificacoesNaoLidas() {
  try {
    const { count } = await sb.from('notificacoes')
      .select('id', { count: 'exact', head: true })
      .eq('usuario_id', tenant.user?.id).eq('lida', false);
    return count || 0;
  } catch (e) { return 0; }
}

function _tempo(iso) {
  if (!iso) return '';
  const min = Math.floor((Date.now() - new Date(iso).getTime()) / 60000);
  if (min < 1) return 'agora';
  if (min < 60) return `${min}min`;
  const h = Math.floor(min / 60);
  if (h < 24) return `${h}h`;
  return `${Math.floor(h / 24)}d`;
}

export async function abrirNotificacoesMobile() {
  let lista = [];
  try {
    const { data } = await sb.from('notificacoes')
      .select('id,titulo,mensagem,lida,created_at')
      .eq('usuario_id', tenant.user?.id)
      .order('created_at', { ascending: false }).limit(40);
    lista = data || [];
  } catch (e) { /* mostra vazio */ }

  const body = lista.length ? `
    <div style="display:flex;flex-direction:column;gap:8px;max-height:62vh;overflow:auto">
      ${lista.map((n) => `
        <div style="padding:11px 13px;border-radius:11px;background:var(--bg2,rgba(255,255,255,.04));border:1px solid var(--glass-border,rgba(255,255,255,.08));${n.lida ? 'opacity:.62' : ''}">
          <div style="display:flex;justify-content:space-between;gap:8px;align-items:baseline">
            <div style="font-weight:600;font-size:13px;word-break:break-word">${esc(n.titulo || '')}</div>
            <div style="font:500 10px 'IBM Plex Mono',monospace;color:var(--text3);flex-shrink:0">${_tempo(n.created_at)}</div>
          </div>
          ${n.mensagem ? `<div style="font-size:12px;color:var(--text3);margin-top:3px;word-break:break-word">${esc(n.mensagem)}</div>` : ''}
        </div>`).join('')}
    </div>` : `
    <div style="text-align:center;padding:42px 16px;color:var(--text3)">
      <div style="font-size:40px;margin-bottom:10px">🔔</div>
      <div style="font-size:13px">Nenhuma notificação por enquanto.</div>
    </div>`;

  openModal({ titulo: 'Notificações', codigo: 'AVISOS', body });

  // Marca todas como lidas + limpa o badge do sino.
  try {
    await sb.from('notificacoes').update({ lida: true })
      .eq('usuario_id', tenant.user?.id).eq('lida', false);
    document.querySelector('.mtb-badge')?.remove();
  } catch (e) { /* ok */ }
}

// Incrementa o badge do sino mobile (usado pelo realtime ao chegar nova notificação).
export function incrementarBadgeMobile() {
  const bell = document.querySelector('[data-mtb="bell"]');
  if (!bell) return;
  let b = bell.querySelector('.mtb-badge');
  if (!b) { b = document.createElement('span'); b.className = 'mtb-badge'; bell.appendChild(b); }
  const n = (parseInt(b.textContent, 10) || 0) + 1;
  b.textContent = n > 9 ? '9+' : String(n);
}
